class Imagen {

    path: string;

    descripcion: string;

    constructor(path: string, descripcion: string) {
        this.path = path;
        this.descripcion = descripcion;
    }

}

export default Imagen;